import React from 'react';
import { Paper as MuiPaper } from '@mui/material';
import { PaperProps } from './model';
export type { PaperProps } from './model';

export const Paper: React.FC<PaperProps> = React.forwardRef<HTMLDivElement, PaperProps>((props, ref) => {
  return <MuiPaper ref={ref} {...props} />;
});
